import { Component, Injector, OnDestroy, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { TBSBaseComponent } from 'src/app/shared/models/tbsBaseComponent';
import { Router } from '@angular/router';

@Component({
    selector: 'app-sso-router',
    templateUrl: './sso-router.component.html',
    styles: [],
    standalone: false
})
export class SsoRouterComponent extends TBSBaseComponent implements OnInit, OnDestroy {
  isFromBrowseBenefits = false;
  lineObject: any;
  constructor(
    private readonly injector: Injector,
    private readonly router: Router,
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2
  ) {
    super(injector);
    if (window.opener && window.opener != null && !window.opener.closed) {
      let fullUrl = this.baseUrl + '/ssorouter'
      window.opener.location.href = fullUrl;
      window.close();
    }
  }

  ngOnInit(): void {
    this.helperService.appendAiElement(this.elementRef, this.renderer);
  }
  ngOnDestroy(): void {
    this.signalUnsubscribe();
  }

}
